import ReactLoading from 'react-loading';

type Props = {
  size?: string;
};

export function InlineLoader({ size = '64px' }: Props) {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        alignItems: 'center',
      }}
    >
      <ReactLoading color={'#9AA6DA'} type="spokes" width={size} height={size} />
    </div>
  );
}
